import {EventEmitter, Injectable} from '@angular/core';
import {TranslateService}         from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class AppService {

	lang: string;
	lang$ = new EventEmitter<String>();

	translate: TranslateService;
	translates: TranslateService[] = [];

	setLang(lang: string) {
		if (lang !== this.lang) {
			this.lang = lang;
			this.lang$.emit(lang);
			const html = document.documentElement;
			html.setAttribute('lang', lang);
			html.className = html.className.replace(/lang_[^\s]+/g, '') + ' lang_' + lang;
			this.translate.use(lang);
			this.translates.forEach(translate => translate.use(lang));
		}
		return this;
	}
	
	setTranslate(translate: TranslateService){
		this.translate = translate;
		return this;
	}

	setChildTranslate(translate: TranslateService) {
		translate.use(this.lang);
		this.translates.push(translate);
		return this;
	}
}
